import { memo, useContext } from 'react';

import type { UseWizard } from '../../../hooks/useWizard';
import { WizardContext } from '../contexts/Wizard.context';
import { WizardStep, type WizardStepProps } from './WizardStep';

type WizardStepWithContextProps = Omit<WizardStepProps, keyof UseWizard[0]>;

export const WizardStepWithContextBase = (props: WizardStepWithContextProps) => {
  const [stepProps] = useContext(WizardContext);

  return <WizardStep {...props} {...stepProps} />;
};

WizardStepWithContextBase.displayName = 'WizardStepWithContextBase';

export const WizardStepWithContext = memo(WizardStepWithContextBase);
